import {Component, ElementRef, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {CompanyEventsListManagerService} from "./company-events-list-manager.service";
import {Apollo} from "apollo-angular";
import {get_company_event_dates, get_employee_users} from "../graphql/getCompanyEvents";
import {startWith, Subscription} from "rxjs";
import {DatePipe} from "@angular/common";
import {Router} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";
import {DateTimeService} from "../../services/date-time.service";
import {map} from "rxjs/operators";
import {parse} from "graphql/language";
import CompanyEventDate from "../../interfaces/company-event-date";

@Component({
    selector: 'app-company-events-list',
    templateUrl: './company-events-list.component.html',
    styleUrls: ['./company-events-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsListComponent implements OnInit{

  private start: any = null
  private end:any = null
  public upcomingEvents: { [key:string] : any} = {}
  public filterEvents: { [key:string] : any} = {}
  public users:any[] = [];
  public filteredUsers: any[] = []
  public isLoading: boolean = false;
  public sectionTitle = "Upcoming Events";
  public dateFormGroup = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null)
  })

  public userSelect = new FormControl(null)

  constructor(public listManager: CompanyEventsListManagerService, private apollo: Apollo, private datePipe: DatePipe, private router: Router, private el: ElementRef, private renderer: Renderer2, private dateTime: DateTimeService) {
  }

  ngOnInit() {
    let dates = this.listManager.getDates();
    this.start = dates.start
    this.end = dates.end
    this.dateFormGroup.setValue({
      start: this.start,
      end: this.end
    })
    this._getListEvents(this.start, this.end)
    this._getUsersForFilter()
    this.userSelect.valueChanges.subscribe((d) => {
      let searchVal = d || ''
      this.filteredUsers = this.users.filter((user) => user.name.toLowerCase().includes(searchVal.toLowerCase()))
    })
  }

  _getListEvents(start:any, end:any){
    let querySubscription: Subscription
    this.isLoading = true;
    querySubscription = this.apollo.watchQuery({
      query: get_company_event_dates,
      variables: {
        start: this.datePipe.transform(start, 'yyyy-MM-dd'),
        end: this.datePipe.transform(end, 'yyyy-MM-dd')
      }
    }).valueChanges.subscribe(({data}:any) => {
      this.upcomingEvents = this.setDateGroupings(data.companyEventDates)
      this.filterEvents = {...this.upcomingEvents}
      this.filterEvents = this.setAppliedFilters(this.filterEvents)
      this.isLoading = false
    })

  }

  _getUsersForFilter(){
    let querySubscription: Subscription
    querySubscription = this.apollo.watchQuery({
      query: get_employee_users
    }).valueChanges.subscribe(({data}:any) => {
      let users = data.get_active_users
      let userData = {}
      users.forEach((user:any) => {
        userData = {id: user.id, name: user.name}
        this.users.push(userData)
      })

    })
  }

  filterByAttendee(e:any){
    let attendeeName = e.option.value.toLowerCase()
    let months = Object.keys(this.filterEvents)
    let filteredObj: {[key:string]: any} = {}
    months.forEach((month:string) => {
      let monthEvents = this.filterEvents[month].events;
      let monthYear = this.filterEvents[month].year
      let foundUserEvents:any[] = []
      for(let j = 0; j < monthEvents.length; j++) {
        if(monthEvents[j].companyEvent.companyEventAttendees.find((person: any) => person.person.name.toLowerCase() == attendeeName)){
          foundUserEvents.push(monthEvents[j])
        }
      }
      filteredObj[month] = {year: monthYear, events: [...foundUserEvents]}
    })
    this.filterEvents = {...filteredObj}
  }

  inputEvent(e:any) {
    let inputString = e.target.value;
    if(inputString==''){
      this.resetAttendeeEvents()
    }
  }

  resetAttendeeEvents(){
    this.userSelect.reset()
    this.filterEvents = {...this.upcomingEvents}
  }

  sortKey() {
    return 0
  }

  setDateGroupings(events: any[]){
    return events.reduce((groups, item) => {
      let parseDate = item.start_date.split('-').join('/')
      let startDate = new Date(parseDate)
      let month = startDate.toLocaleString('en', {month: 'long'})
      if (!groups[month]) {
        groups[month] = {
          events: [],
          year: startDate.getFullYear()
        };
      }
      groups[month].events.push(item);
      return groups;
    }, {})
  }

  setAppliedFilters(events:any){
    let displayList = this.listManager.fetchTypeDisplays();
    let months = Object.keys(events)
    let filteredEvents:any = {}
    months.forEach((month) => {
      let event = events[month]
      filteredEvents[month] = {year: event.year, events: []}
      for (let j = 0; j < event.events.length; j++){
        let itemType = event.events[j].companyEvent.companyEventType.name
        let itemIsBlocked = displayList.find((type:any) => type.key == itemType && type.display=='none');
        if(!itemIsBlocked){
          filteredEvents[month].events.push(event.events[j])
        }
      }
    })
    return filteredEvents
  }
  navigate(data:any, type?:string){
    if(!type && data){
      let companyId = data.companyEvent.id;
      const url = this.router.serializeUrl(this.router.createUrlTree(['/company_events/' + companyId]))
      window.open(url, '_blank')
    } else {
      this.router.navigate(['/company_events/calendar'])
    }
  }

  toggleGroup(key: string){
    let display = this.listManager.toggleEventDisplay(key)
    let months = Object.keys(this.filterEvents)
    let filterObj: {[key:string]: any} = {}
    for(let i = 0; i < months.length; i++){
      let events = this.filterEvents[months[i]]
      let year = this.filterEvents[months[i]].year
      if(display=='none'){
        let newEvents = events.events.filter((event:any) => event.companyEvent.companyEventType.name!==key);
        filterObj[months[i]] = {year: year, events: [...newEvents]}
      } else {
        let newEvents = this.upcomingEvents[months[i]].events.filter((event:any) => {
          let hasFilteredUser = this.userSelect.value!==null;
          if(event.companyEvent.companyEventType.name==key && !hasFilteredUser){
            return event
          }
          if(event.companyEvent.companyEventType.name==key && hasFilteredUser){
            let userAssignedToEvent = event.companyEvent.companyEventAttendees.find((person:any) => person.person.name == this.userSelect.value);
            if(userAssignedToEvent){
              return event;
            }
          }
        });
        this.filterEvents[months[i]].events.push(...newEvents)
        this.filterEvents[months[i]].events.sort((a:any,b:any) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime())
        filterObj = {...this.filterEvents}
      }
    }
    this.filterEvents = {...filterObj}

  }


  onDateChange(){
    this.userSelect.reset()
    this.dateFormGroup.controls.end.valueChanges.subscribe((endValue) => {
      let end = endValue;
      let start = this.dateFormGroup.controls.start.value;
      if(this._validateDateChanges(start, end)){
        this._getListEvents(start, end)
      }
    })
  }

  _validateDateChanges(start:any, end:any){
    if(start == null || end == null){
      return false;
    }
    if(start.getTime() > end.getTime()){
      return false
    }
    return true;
  }

  public quickExportCompanyEventList(){
    const allEvents: CompanyEventDate[] = Object.values(this.filterEvents).flatMap(month => month.events)
    const exportedBody = this.listManager.formatCompanyListForExport(allEvents)
    this.listManager.exportCompanyEventList(exportedBody).then((result) => {});
  }

  protected readonly Object = Object;
}
